import React, { useState } from "react";
import { useOnboarding } from "../../hooks";
import { ModalDialog } from "../modal-dialog";
import { OnboardingSteps } from "../../feature/onboarding/onboarding-steps";
import "./sidebar-setup-indicator.scss";

export const SidebarSetupIndicator = (): JSX.Element | null => {
  const { steps, completed, total, allDone, ready } = useOnboarding();
  const [open, setOpen] = useState(false);

  // Stays visible (even after the dashboard card is dismissed) until setup is complete
  if (!ready || allDone) return null;

  const pct = Math.round((completed / total) * 100);
  const left = total - completed;

  return (
    <>
      <button
        className="sidebar-setup"
        onClick={() => setOpen(true)}
        title="Finish setting up Upwex"
      >
        <span
          className="sidebar-setup__ring"
          style={{ "--pct": `${pct}%` } as React.CSSProperties}
        >
          <span className="sidebar-setup__ring-label">
            {completed}/{total}
          </span>
        </span>
        <span className="sidebar-setup__text">
          <span className="sidebar-setup__title">Finish setup</span>
          <span className="sidebar-setup__sub">
            {left} step{left > 1 ? "s" : ""} left
          </span>
        </span>
      </button>

      <ModalDialog
        isOpen={open}
        onCancel={() => setOpen(false)}
        title={null}
        className="onboarding-modal"
      >
        <OnboardingSteps steps={steps} completed={completed} total={total} />
      </ModalDialog>
    </>
  );
};

export default SidebarSetupIndicator;
